import React from "react";
import FancyCards from "../components/FancyCards/FancyCards";
import { DataSellDomainsQuestions } from "../components/FAQs/Data";
import Questions from "../components/FAQs/Questions";
import TopBar from "../components/TopBar";
import Footerr from "../components/Footerr/Footerr";
import ProgressBar from "../components/ProgressBar";

function SellDomains() {
  return (
    <div>
      {" "}
      <ProgressBar />
      <TopBar />
      <FancyCards />
      <Questions data={DataSellDomainsQuestions} />
      <Footerr />
    </div>
  );
}

export default SellDomains;
